import { useState } from 'react';
import NotificationIcons from './NotificationIcons';

const settingsTabs = [
  { 
    label: 'Profile', 
    icon: '/img/profile.svg', 
    value: 'profile'
  },
  { 
    label: 'Users', 
    icon: '/img/users.svg', 
    value: 'users'
  },
  { 
    label: 'MKT Configuration', 
    icon: '/img/configuration.svg', 
    value: 'mkt_configuration'
  },
  { 
    label: 'Label', 
    icon: '/img/label.svg', 
    value: 'label'
  },
  { 
    label: 'Fulfillment Card', 
    icon: '/img/parcel.svg', 
    value: 'fulfillment_card'
  },
];

export default function SettingsTabs({ 
  selected, 
  onSelect, 
  onSubStatusSelect,
  selectedSubStatus
}: {
  selected?: string;
  onSelect?: (status: string) => void;
  onSubStatusSelect?: (subStatus: string) => void;
  selectedSubStatus?: string;
}) {
  const [activeStatus, setActiveStatus] = useState(selected || 'profile');
  const [activeSubStatus, setActiveSubStatus] = useState(selectedSubStatus || 'user_list');

  const handleStatusClick = (statusValue: string) => {
    setActiveStatus(statusValue);
    onSelect?.(statusValue);
    
    // Reset sub-status when switching to Users tab
    if (statusValue === 'users') {
      setActiveSubStatus('user_list');
      onSubStatusSelect?.('user_list');
    }
  };

  const handleSubStatusClick = (subStatusValue: string) => {
    setActiveSubStatus(subStatusValue);
    onSubStatusSelect?.(subStatusValue);
  };

  return (
    <div className="space-y-4">
      {/* Main Settings Tabs */}
      <div className="flex justify-between items-center mb-6 mt-[-50px] overflow-x-auto py-3 bg-gray-200 px-8 outline outline-1 outline-gray-200 relative z-10">
        <div className="flex gap-3">
          {settingsTabs.map((status) => {
            const isSelected = activeStatus === status.value;
            return (
              <button
                key={status.value}
                className={`flex items-center gap-2 px-4 py-2.5 text-sm font-medium transition-colors whitespace-nowrap cursor-pointer
                  ${isSelected
                    ? 'text-primary-500'
                    : 'text-gray-600 hover:text-primary-500/40'}
                `}
                onClick={() => handleStatusClick(status.value)}
              >
                <div className={`w-11 h-11 rounded-lg flex items-center justify-center transition-colors ${
                  isSelected ? 'bg-primary-500' : 'bg-white hover:bg-gray-50'
                }`}>
                  <img
                    src={status.icon}
                    alt={status.label}
                    className="w-6 h-6"
                  />
                </div>
                <span>
                  {status.label === 'MKT Configuration' ? (
                    <>MKT<br />Configuration</>
                  ) : status.label === 'Fulfillment Card' ? (
                    <>Fulfillment<br />Card</>
                  ) : (
                    status.label
                  )}
                </span>
              </button>
            );
          })}
        </div>

        {/* Notification Icons */}
        <NotificationIcons />
      </div>

      {/* Sub-status tabs for Users */}
      {activeStatus === 'users' && (
        <div className="px-8 mt-4 relative z-0">
          <div className="flex mt-[-30px] mb-8 ml-[100px] w-fit relative z-0">
            {[
              { label: 'User List', value: 'user_list' },
              { label: 'Roles', value: 'roles' }
            ].map((subStatus, index) => {
              const isSelected = selectedSubStatus === subStatus.value || activeSubStatus === subStatus.value;
              const overlapClass = index === 0 ? '' : '-ml-6';
              
              return (
                <button
                  key={subStatus.value}
                  className={`${overlapClass} px-8 py-2.5 first:pl-7 last:pr-7 text-sm font-medium transition-colors whitespace-nowrap cursor-pointer inline-flex items-center justify-center rounded-full border relative
                    ${isSelected 
                      ? 'bg-[#FFF8D6] text-[#D4A017] font-semibold border-[#F2BC00]' 
                      : 'bg-white text-[#1E3255] border-[#4B5675] hover:bg-[#F7F9FC]'
                    }
                  `}
                  style={{ zIndex: 20 - index }}
                  onClick={() => handleSubStatusClick(subStatus.value)}
                >
                  {subStatus.label}
                </button>
              );
            })}
          </div>
        </div>
      )}
    </div>
  );
}
